import React from 'react'
import { LiaBirthdayCakeSolid } from "react-icons/lia"
import { HiOutlineLocationMarker } from "react-icons/hi"
import { TbUserShield } from "react-icons/tb"
import useAppContext from '../../hook/useAppContext'
import Online from '../online/Online'
import './user.css'

const User = () => {

      const {user, data, break_line} = useAppContext()
      const {personal} = user 

      if(personal.code) return 

      const name = personal.name 
      const status = personal.status 
      const id = personal.id_xat
      const avatar = personal.avatar
      const flag = personal.country_flag === null ? "" : personal.country_flag 
      const country = personal.country === null ? "" : personal.country
      const birthday = personal.date === null ? "" : personal.date.birthday 
      const location = personal.location.length === 0 ? data.info.location : personal.location
      const about = personal.about 
      const forum = personal.forum.length === 0 ? data.info.forum : personal.forum 
      const xat_room = personal.xat_room.length === 0 ? data.info.xat_room : personal.xat_room

      return (
            <div className="user_content">
                  <div className="user_wrapper">
                        <div className="user_header flex">
                              <div className="user_data">
                                    <div className="user_data__info">
                                          <div className="user_info__title flex">
                                                <h1>{name}</h1>
                                                {flag.length > 0 ? <img src={flag} alt={country} /> : ""}
                                          </div>
                                          <p>{status}</p>
                                          <Online id={id} />
                                    </div>
                                    <div className="user_data__nav flex">
                                          <a href={xat_room} target="_blank" rel="noreferrer">Chat</a>
                                          <a href={forum} target="_blank" rel="noreferrer">Forum</a>
                                    </div>
                                    <div className="user_data__details">
                                          <ul>
                                                <li className="flex">
                                                      <TbUserShield />
                                                      <span>{id}</span>
                                                </li>
                                                {
                                                      birthday.length !== 0 
                                                       ? <li className="flex">
                                                            <LiaBirthdayCakeSolid />
                                                            <span>{birthday}</span>
                                                       </li>
                                                       : ""
                                                }
                                                
                                                <li className="flex">
                                                      <HiOutlineLocationMarker />
                                                      <span>{location}</span>
                                                </li>
                                          </ul>
                                    </div>
                              </div>
                              <div className="user_avatar">
                                    <div className="user_avatar__img flex">
                                          <img src={avatar} alt={name} />
                                    </div>
                              </div>
                        </div>
                        <div className="user_about">
                              <p>{break_line(about)}</p>
                        </div>
                  </div>
            </div>
      )
}

export default User
